const INTERACTIVE_SELECTOR = [
    'a',
    'button',
    'input',
    'label',
    'select',
    'textarea',
    '[role="button"]',
    '[role="checkbox"]',
    '[role="combobox"]',
    '[role="menuitem"]',
    '[role="switch"]',
    '.MuiSwitch-root',
    '.MuiCheckbox-root',
    '.MuiChip-clickable',
    '.MuiChip-deletable',
].join(',');

const landedOnInteractiveElement = event => !!event.target?.closest?.(INTERACTIVE_SELECTOR);

const hasTextSelectionWithin = row => {
    const selection = window.getSelection?.();
    return !!selection && !selection.isCollapsed && !!row?.contains(selection.anchorNode);
};

export const guardedRowClick = action =>
    action &&
    (event => {
        if (landedOnInteractiveElement(event) || hasTextSelectionWithin(event.currentTarget)) {
            return;
        }
        action();
    });
